// Utility function to check if a value is considered "empty" for our purposes.
// Now checks for empty arrays, null, empty strings, and undefined values.
export const isEmptyValue = (value: any): boolean => {
	return (
		value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0) // Checks if the value is an empty array
	);
};
